/* global.js — progressive enhancement, no dependencies */
(function () {
  'use strict';

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
    // safety net: never leave content hidden
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-visible'); }); }, 2500);
  }

  /* ---- Mobile navigation drawer ---- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    var overlay = document.querySelector('[data-overlay]');
    if (!nav) return;
    function open() {
      nav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-mobile-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-mobile-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Carousel arrows ---- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      root.querySelectorAll('[data-carousel-prev]').forEach(function (b) {
        b.addEventListener('click', function () { scrollBy(track, -1); });
      });
      root.querySelectorAll('[data-carousel-next]').forEach(function (b) {
        b.addEventListener('click', function () { scrollBy(track, 1); });
      });
    });
    function scrollBy(track, dir) {
      var card = track.querySelector('.card');
      var gap = 22;
      var step = card ? card.offsetWidth + gap : 322;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initReveal();
    initMobileNav();
    initCarousels();
  });
})();
